import { render } from "./HeroiconsSolidMicrophone.vue?vue&type=template&id=11aa669b"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMicrophone.vue"]])

export default __exports__